
export default function About() {
  return (
    <section id="about-us" className="py-24 bg-gradient-to-b from-[#F5F5F0] to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="relative h-[600px] w-full rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://static.readdy.ai/image/996388af2a2c408cf3ec99d47234a378/e7f623be6efc4f4c9cdf5af34d069f99.jpeg"
                alt="Our Team"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-8 -right-8 bg-[#D4AF37] text-white p-8 rounded-2xl shadow-xl max-w-xs">
              <div className="text-5xl font-bold mb-2">10+</div>
              <div className="text-white/90">Years of experience creating memorable events</div>
            </div>
          </div>

          <div>
            <div className="inline-block mb-4 px-6 py-2 bg-[#D4AF37]/10 rounded-full border border-[#D4AF37]/20">
              <span className="text-[#D4AF37] text-sm font-semibold tracking-wide">ABOUT US</span>
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-gray-900 font-bold mb-6 leading-tight">
              Experts in Creating<br />Unforgettable Moments
            </h2>
            <p className="text-gray-600 text-lg mb-6 leading-relaxed">
              We are a company specialized in event organization with over 10 years of experience. Our team of professionals is dedicated to making your dream celebration a reality.
            </p>
            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
              From elegant weddings to corporate events, birthdays and family gatherings, we take care of every detail so you can just enjoy.
            </p>

            <div className="space-y-6 mb-10">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#D4AF37] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-white text-2xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 text-lg mb-1">Highly Trained Staff</h4>
                  <p className="text-gray-600">Professional waiters and staff with years of experience in high-level events</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#D4AF37] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-white text-2xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 text-lg mb-1">First-Class Catering</h4>
                  <p className="text-gray-600">Customized menus with fresh ingredients and impeccable presentation</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#D4AF37] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-white text-2xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 text-lg mb-1">Personalized Attention</h4>
                  <p className="text-gray-600">Each event is unique and deserves a service tailored to your specific needs</p>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap gap-4">
              <button 
                onClick={() => {
                  const element = document.getElementById('contact');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                className="bg-[#D4AF37] text-white px-8 py-3 rounded-full font-semibold hover:bg-[#C5A028] transition-all inline-flex items-center gap-2 whitespace-nowrap cursor-pointer shadow-lg"
              >
                Contact Us
                <i className="ri-arrow-right-line"></i>
              </button>
              <button 
                onClick={() => {
                  const element = document.getElementById('services');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                className="bg-white text-[#D4AF37] px-8 py-3 rounded-full font-semibold border-2 border-[#D4AF37] hover:bg-[#D4AF37] hover:text-white transition-all whitespace-nowrap cursor-pointer"
              >
                View Services
              </button>
            </div>
          </div>
        </div>

        <div className="mt-24 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
            <i className="ri-trophy-line text-5xl text-[#D4AF37] mb-4"></i>
            <div className="text-4xl font-bold text-gray-900 mb-2">500+</div>
            <div className="text-gray-600">Successful Events</div>
          </div>
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
            <i className="ri-team-line text-5xl text-[#D4AF37] mb-4"></i>
            <div className="text-4xl font-bold text-gray-900 mb-2">50+</div>
            <div className="text-gray-600">Professionals</div>
          </div>
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
            <i className="ri-star-line text-5xl text-[#D4AF37] mb-4"></i>
            <div className="text-4xl font-bold text-gray-900 mb-2">98%</div>
            <div className="text-gray-600">Satisfaction</div>
          </div>
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
            <i className="ri-calendar-line text-5xl text-[#D4AF37] mb-4"></i>
            <div className="text-4xl font-bold text-gray-900 mb-2">10+</div>
            <div className="text-gray-600">Years Experience</div>
          </div>
        </div>
      </div>
    </section>
  );
}
